import { render, staticRenderFns } from "./OStep4.vue?vue&type=template&id=01455d3a&scoped=true"
import script from "./OStep4.vue?vue&type=script&lang=js"
export * from "./OStep4.vue?vue&type=script&lang=js"
import style0 from "./OStep4.vue?vue&type=style&index=0&id=01455d3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01455d3a",
  null
  
)

export default component.exports